import { useState } from 'react';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Popover, Typography } from '@mui/material';
import { ContactAlertButton, ContactAlertList, ContactAlertListItem } from '@styles/ContactManager/ContactStyles';
import { INotification } from './interfaces';

interface ContactAlertPopOverProps {
  alertMessages: INotification[];
}

export const ContactAlertPopOver = ({ alertMessages }: ContactAlertPopOverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const maxWidth = alertMessages.length > 1 ? '230px' : '100%';

  return (
    <>
      <ContactAlertButton
        aria-describedby={id}
        $messageColor={alertMessages[0]?.color}
        variant="contained"
        onClick={handleClick}
      >
        <ErrorOutlineOutlinedIcon />
        <Typography
          noWrap
          variant="subtitle1"
          display="block"
          marginLeft="10px"
          maxWidth={maxWidth}
          overflow="hidden"
          textOverflow="ellipsis"
          fontWeight="bold"
        >
          {alertMessages.length > 1 ? `${alertMessages.length} Alerts` : `${alertMessages[0]?.key}: ${alertMessages[0]?.message}`}
        </Typography>
      </ContactAlertButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
      >
        <ContactAlertList>
          {alertMessages?.map((notification, index) => (
            <ContactAlertListItem
              key={index}
              isLastItem={alertMessages?.length - 1 !== index}
              primary={`${notification?.key}: ${notification?.message}`}
              primaryTypographyProps={{
                color: `${notification?.color}`,
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            />
          ))}
        </ContactAlertList>
      </Popover>
    </>
  );
};
